export default "__VITE_ASSET__0$Xn7Gcp__";